import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import makeStyles from "@mui/styles/makeStyles";

// Substituto do makeStyles com estilo agrupado
const styles = makeStyles(() => ({
  radioLabel: {
    alignItems: "center !important",
    display: "flex !important",
    flexDirection: "row",

    "& span:nth-of-type(2)": {
      color: colors.gray600,
      fontFamily: "Manrope",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "24px",
      letterSpacing: "0.5px",
      margin: 0,
    },
  },
  iconError: {
    marginRight: "5px",
    fontSize: "16px",
  },
  formHelper: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "14px",
    lineHeight: "24px",
    color: "#D92D20",
    alignItems: "center",
    display: "flex",
    margin: 0,
  },
}));

export const HeaderWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

interface ITitle {
  disabled?: boolean;
}

export const Title = styled("span")(({ disabled }: ITitle) => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "24px",
  color: disabled ? "#667085" : colors.brandBlue600,
}));

export const RequiredLabel = styled("span")(() => ({
  color: colors.error500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  marginLeft: "2px",
}));

export const Description = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

export default styles;
